(function () {
	const WIDE = 1024;

	function openModal(inline) {
		const overlay = document.createElement('div');
		overlay.className = 'hero-video-modal';

		const inner = document.createElement('div');
		inner.className = 'hero-video-modal__inner';

		const video = document.createElement('video');
		video.controls = true;
		video.autoplay = true;
		video.playsInline = true;
		if (inline.poster) video.poster = inline.poster;
		Array.prototype.forEach.call(inline.querySelectorAll('source'), function (source) {
			video.appendChild(source.cloneNode(true));
		});

		const close = document.createElement('button');
		close.className = 'hero-video-modal__close';
		close.setAttribute('aria-label', 'Close video');
		close.innerHTML = '&times;';

		inner.appendChild(close);
		inner.appendChild(video);
		overlay.appendChild(inner);
		document.body.appendChild(overlay);

		requestAnimationFrame(() => overlay.classList.add('is-open'));

		function closeModal() {
			overlay.classList.remove('is-open');
			video.pause();
			overlay.addEventListener('transitionend', () => overlay.remove(), { once: true });
			document.removeEventListener('keydown', onKey);
		}

		close.addEventListener('click', closeModal);
		overlay.addEventListener('click', function (e) {
			if (e.target === overlay) closeModal();
		});

		function onKey(e) {
			if (e.key === 'Escape') closeModal();
		}
		document.addEventListener('keydown', onKey);
	}

	function init() {
		const wrap = document.querySelector('.hero-home .video');
		if (!wrap) return;

		const inline = wrap.querySelector('video');
		if (!inline) return;

		wrap.style.cursor = 'pointer';

		wrap.addEventListener('click', function () {
			if (window.innerWidth < WIDE) return;
			inline.pause();
			openModal(inline);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
